<template>
  <div id="theme-settings" style="font-family: 'Montserrat';">
    <v-toolbar color="#F9FAFD" dark class="toolbar-card" style="height: 80px;">
      <v-toolbar-title style="font-size: 24px; font-weight: 600; line-height: 32px; height: 32px; color: #161A40; font-family: 'Montserrat';">Theme Settings</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <v-layout wrap>
        <v-flex>
          <v-subheader class="px-1 my-2">
            Font Family
          </v-subheader>
          <div class="font-option">
            <v-layout row wrap>
              <v-flex lg12 v-for="(option,index) in fontFamilyOptions" :key="index">
                <label
                  class="font-option--label flex xs12 pa-1"
                  :style="`fontFamily: ${option.font}`"
                >
                  <input type="radio" name="font" v-bind:value="option.font" v-model="fontType">
                  <span class="font-option--item bg">
                  <span class="overlay">
                    <span class="material-icons">check</span>
                  </span>
                  <span class="sideMenu" :class="`rgba${themeRGB}`">{{ option.font }}</span>
                </span>
                </label>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
      <v-layout column>
        <v-flex>
          <v-subheader class="px-1 my-2">
            Color Option
          </v-subheader>
          <div class="color-option">
            <v-layout wrap>
              <label
                class="color-option--label flex xs6 pa-1"
                v-for="(option,index) in themeColorOptions"
                :key="index"
              >
                <input type="radio" name="color" v-bind:value="option.key" v-model="themeColor" @click="themeRGB=option.rgba">
                <span class="color-option--item bg">
                <span class="overlay">
                  <span class="material-icons">check</span>
                </span>
                <span class="color-option--item--header sideNav" :class="option.value.sideNav"></span>
                <span class="color-option--item--header mainNav" :class="option.value.mainNav"></span>
                <span class="sideMenu" :class="option.value.sideMenu"></span>
              </span>
              </label>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import colors from 'vuetify/lib/util/colors'
import { LIST_THEME_OPTION } from '@/setting/list-info/list-theme-option'

export default {
  name: 'theme-settings',
  data () {
    return {
      themeColor: 'lightBlue',
      themeRGB: '(3, 169, 244, 0.1)',
      sideBarOption: 'light',
      colors: colors,
      fontType: 'Montserrat'
    }
  },
  computed: {
    themeColorOptions () {
      return LIST_THEME_OPTION.themeColorOptions
    },
    fontFamilyOptions () {
      return LIST_THEME_OPTION.fontFamilyOptions
    }
  },
  watch: {
    themeColor: {
      handler (val) {
        this.$vuetify.theme.themes.light.primary = this.colors[val].base
        this.$vuetify.theme.themes.light.secondary = this.colors[val].lighten5
        const colorText = val.replace(/[A-Z]/g, function (letter) {
          return '-' + letter
        }).toLowerCase()
        this.store.commit('setColorText', colorText)
      },
      immediate: true
    },
    fontType: {
      handler (val) {
        this.store.commit('setFontFamily', val)
      },
      immediate: true
    },
    sideBarOption: {
      handler (val) {
        this.$vuetify.theme.dark = val === 'dark'
      },
      immediate: true
    }
  }
}
</script>
<style>
  #theme-settings .flex {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .toolbar-card.v-sheet.v-toolbar:not(.v-sheet--outlined) {
    box-shadow: none;
  }
</style>
<style lang='sass' scoped>
.font-option
  &--label
    position: relative
    display: block
    cursor: pointer
    & input[type="radio"]
      display: none
      &+span
        position: relative
        &>.overlay
          display: none
          position: absolute
          top: 0
          bottom: 0
          right: 0
          left: 0
          width: 100%
          height: 100%
          background-color: rgba(0,0,0,.3)
          text-align: center
          line-height: 30px
          color: #fff
      &:checked+span>.overlay
        display: block
    & .bg
      background-color: #f1f1f1
  &--item
    overflow: hidden
    display: block
    box-shadow: 0 0 2px rgba(0,0,0,.1)
    padding-top: 8px
    margin-bottom: 15px
    font-size: 18px
    text-align: center
    &--header
      height: 10px
    &>span
      display: block
      float: left
      width: 100%
      height: 32px
.color-option
  &--label
    position: relative
    display: block
    cursor: pointer
    & input[type="radio"]
      display: none
      &+span
        position: relative
        &>.overlay
          display: none
          position: absolute
          top: 0
          bottom: 0
          right: 0
          left: 0
          width: 100%
          height: 100%
          background-color: rgba(0,0,0,.3)
          text-align: center
          line-height: 30px
          color: #fff
      &:checked+span>.overlay
        display: block
    & .bg
      background-color: #f1f1f1
  &--item
    overflow: hidden
    display: block
    box-shadow: 0 0 2px rgba(0,0,0,.1)
    margin-bottom: 15px
    &--header
      height: 10px
    &>span
      display: block
      float: left
      width: 50%
      height: 20px
</style>
